module.exports = __webpack_public_path__ + "img/team-member-03.b9c4559e.jpg";